export interface IApplicationDefinitionSummary {
  id: string;
  title: string;
  publicTitle: string;
  hasExpired: boolean;
  isArchived: boolean;
  workspaceId: string | null;
}
export class ApplicationDefinitionSummary implements IApplicationDefinitionSummary {
  public id: string;
  public title: string;
  public publicTitle: string;
  public deadline: Date;
  public hasExpired: boolean;
  public requestUri: string;
  public formType: string;
  public isArchived: boolean;
  public workspaceId: string | null;
  public isPrivate: boolean;
  public createTeam: boolean;

  constructor() {}

  public static parse(data: any): ApplicationDefinitionSummary {
    if (!data) return null;

    let application = new ApplicationDefinitionSummary();
    Object.assign(application, data);

    return application;
  }

  public isSharedFromOrg(isInOrg: boolean): boolean {
    return !isInOrg && !this.workspaceId;
  }
}
